<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <path
      d="M 2,4 L 1,5 L 1,7 L 5,7 L 6,8 L 11,8 L 12,9 L 14,9 L 15,10 L 16,10 L 17,11 L 18,11 L 20,13 L 21,13 L 29,21 L 29,22 L 31,24 L 31,25 L 32,26 L 32,28 L 33,29 L 33,30 L 34,31 L 34,35 L 35,36 L 35,37 L 34,38 L 28,32 L 25,32 L 25,34 L 27,36 L 27,37 L 28,37 L 31,40 L 31,41 L 32,41 L 36,45 L 37,45 L 48,34 L 48,32 L 45,32 L 39,38 L 38,37 L 38,35 L 37,34 L 37,30 L 36,29 L 36,27 L 35,26 L 35,25 L 34,24 L 34,23 L 33,22 L 33,21 L 31,19 L 31,18 L 24,11 L 23,11 L 21,9 L 20,9 L 19,8 L 18,8 L 17,7 L 16,7 L 15,6 L 13,6 L 12,5 L 8,5 L 7,4 Z"
      fill="currentColor"
    />
  </svg>
</template>
